export default __webpack_public_path__ + "static/inmovalles_bird-97b904b5e38e263fefd49783d188a9dc.svg";